import { Link } from "react-router-dom";
import { BrandedHomeLink } from "@/components/BrandedHomeLink";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { getAuthToken } from "@/App";

/**
 * Shared layout for public legal pages (privacy, terms).
 * Signed-in people go back to Settings → Legal instead of the login page.
 */
export default function LegalPageLayout({ title, lastUpdated, children }) {
  const signedIn = Boolean(getAuthToken());
  const backTo = signedIn ? "/settings?tab=legal" : "/login";
  const backLabel = signedIn ? "Back to Settings" : "Back to sign in";

  return (
    <div className="min-h-screen bg-background text-foreground">
      <header className="border-b border-border bg-background/95 sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-4">
          <BrandedHomeLink to={signedIn ? "/dashboard" : "/"} logoClassName="w-8 h-8">
            <span className="font-bold text-lg">TerraKronos</span>
          </BrandedHomeLink>
          <Button variant="ghost" size="sm" asChild>
            <Link to={backTo} className="gap-2">
              <ArrowLeft className="w-4 h-4" />
              {backLabel}
            </Link>
          </Button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10 pb-16">
        <h1 className="font-heading text-3xl font-bold text-foreground mb-2">{title}</h1>
        {lastUpdated && (
          <p className="text-sm text-muted-foreground mb-8">Last updated: {lastUpdated}</p>
        )}
        <div className="prose-legal space-y-6 text-foreground/90 text-sm leading-relaxed">
          {children}
        </div>
        <footer className="mt-12 pt-8 border-t border-border flex flex-wrap gap-4 text-sm text-muted-foreground">
          <Link to="/faq" className="hover:text-foreground transition-colors">
            FAQ
          </Link>
          <Link to="/privacy" className="hover:text-foreground transition-colors">
            Privacy Policy
          </Link>
          <Link to="/terms" className="hover:text-foreground transition-colors">
            Terms of Service
          </Link>
          <Link to="/" className="hover:text-foreground transition-colors">
            Home
          </Link>
        </footer>
      </main>
    </div>
  );
}
